import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { NAMESPACES, snapshotResources } from './i18n-resources';
import {
  readLocalePreference,
  readRequestedLocale,
  resolveInitialLocale,
} from './services/locale-preference';

export const DEFAULT_LOCALE = 'en';

/** Locales the build actually bundles — the header toggle renders from this list. */
export const AVAILABLE_LOCALES: readonly string[] = Object.keys(snapshotResources);

/**
 * `?lng=` → stored preference → browser language prefix → default, restricted
 * to bundled locales. A `?lng=` is honoured for the visit but never stored:
 * only the header toggle remembers a choice. Read on the client AFTER hydration (see `I18nProvider`), never at
 * init: the static export's HTML is English, so i18next boots in English on
 * both server and client and switches once the tree is mounted. Reading
 * `localStorage` / `navigator` here would render Spanish text against English
 * server markup and trip a hydration mismatch.
 */
export function resolveClientLocale(): string {
  return resolveInitialLocale({
    requested: typeof window !== 'undefined' ? readRequestedLocale(window.location.search) : null,
    stored: readLocalePreference(),
    navigatorLanguage: typeof navigator !== 'undefined' ? navigator.language : undefined,
    available: AVAILABLE_LOCALES,
    fallback: DEFAULT_LOCALE,
  });
}

void i18n.use(initReactI18next).init({
  resources: snapshotResources,
  lng: DEFAULT_LOCALE,
  fallbackLng: DEFAULT_LOCALE,
  ns: [...NAMESPACES],
  defaultNS: 'common',
  interpolation: { escapeValue: false },
  returnNull: false,
});

export default i18n;
